import React from 'react';
import styles from './ChecklistEducationBanner.less';
import { forTemplate } from 'app/common/lib/util/i18n';
import { Icon, IconName } from 'app/common/components/controls';
import {
  Analytics,
  Source,
  ActionSubjectId,
} from '@trello/atlassian-analytics';

const format = forTemplate('checklist_education_banner');

interface ChecklistEducationBannerProps {
  onDismiss: () => void;
  idBoard?: string;
  idCard?: string;
  idOrganization?: string;
}

export const ChecklistEducationBanner: React.FunctionComponent<ChecklistEducationBannerProps> = ({
  onDismiss,
  idBoard,
  idCard,
  idOrganization,
}) => {
  const containers = {
    card: {
      id: idCard,
    },
    board: {
      id: idBoard,
    },
    organization: {
      id: idOrganization,
    },
  };

  return (
    <div className={styles.banner}>
      <h2 className={styles.heading}>{format('assign-people-and-dates')}</h2>
      <div className={styles.content}>
        {format('plus-see-all-your-assigned-items', {
          yourItems: (
            <a
              key="your-items"
              target="_blank"
              href="/my/tasks"
              onClick={() =>
                Analytics.sendClickedLinkEvent({
                  linkName: ActionSubjectId.yourItemsLink,
                  source: Source.advancedChecklistEducationBanner,
                  containers,
                })
              }
            >
              {format('your-items')}
            </a>
          ),
        })}
      </div>
      <div className={styles.footer}>
        <a
          target="_blank"
          href="https://help.trello.com/article/942-assigning-people-and-due-dates-to-specific-checklist-items"
          onClick={() =>
            Analytics.sendClickedLinkEvent({
              linkName: ActionSubjectId.advancedChecklistLearnMoreLink,
              source: Source.advancedChecklistEducationBanner,
              containers,
            })
          }
        >
          {format('learn-more')}
        </a>
      </div>
      <button
        className={styles.dismiss}
        onClick={() => {
          onDismiss();

          Analytics.sendClickedButtonEvent({
            buttonName: ActionSubjectId.dismissButton,
            source: Source.advancedChecklistEducationBanner,
            containers,
          });
        }}
      >
        <Icon name={IconName.Close} />
      </button>
    </div>
  );
};
